export const pastelColors = {
  yellow: "rgba(254,255,134,0.3)",
  blue: "rgba(218,245,255,0.5)",
  orange: "rgba(255,222,180,0.4)",
  purple: "rgba(178,164,255,0.3)",
  lightgreen: "rgba(144, 238, 144, 0.25)",
  red: "rgba(253,138,138,0.15)",
  navy: "rgba(0, 0, 128, 0.3)",
};
